import { Navigation } from "./navigation";

export const Header = (props) => {
  const { openModal } = props;

  return (
    <header id='header'>
      <div className='intro'>
        <Navigation />
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-8 col-md-offset-2 intro-text'>
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : 'Loading'}</p>
                { window.innerWidth <= 520 && <img src="img/intro-bg-1.svg" className='intro-bg1'/> }
                <a
                  className='btn btn-blue btn-audit page-scroll'
                  onClick={openModal}
                >
                  Get Audited
                </a>
              </div>
              { window.innerWidth > 520 && <img src="img/intro-bg-1.svg" className='intro-bg1'/> }
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
